import React from "react";
import { Link } from "react-router-dom";

const RememberForgot = () => {
  return (
    <div className="remember-forgot">
      <label>
        <input type="checkbox" /> Remember me
      </label>
      <Link to="/forget">Forgot Password?</Link>
    </div>
  );
};

export default RememberForgot;
